<template>
  <!-- BUMP PRODUCT -->
    <div v-if="data.bumpArray.length > 0
      " class="theme--tuktuk__checkout__bump">
      <div v-for="(bumpData, i) in data.bumpArray" :key="i" class="theme--tuktuk__checkout__bump__item" @click="(e) => { addBumpOrder(e, bumpData) }">
        <div
          class="theme--tuktuk__checkout__bump__item__content"
          :class="[
            bumpData.bumpImage ? 'theme--tuktuk__checkout__bump__item__content--show-thumbnail' : '',
            bumpData.bumpImage && data.isHighlightBumpImage ? 'bump-highlight' : ''
          ]"
        >
          <div
            v-if="bumpData.bumpImage"
            class="theme--tuktuk__checkout__bump__item--show-thumbnail__container bump-thumbnail-zoom"
            role="button"
            aria-label="Lihat foto bump produk"
            @click.stop="$refs.photoViewer.open(getSizedImageUrl(bumpData.bumpImage,'fullView','product-images'))"
          >
            <img :src="getSizedImageUrl(bumpData.bumpImage, data.isHighlightBumpImage ? 'fullView' : 'thumbnail','product-images')" />
            <span class="bump-thumbnail-zoom__overlay">
              <img src="@/assets/icons/bump-zoom/search-white.svg" alt="" width="24" height="24" />
            </span>
          </div>
          <div class="theme--tuktuk__checkout__bump__item__product">
            <div class="theme--tuktuk__checkout__bump__item__product__detail">
              <h3>{{ bumpData.bumpName }}</h3>
              <p v-if="bumpData.bumpDescription">
                {{ bumpData.bumpDescription }}
              </p>
            </div>
            <p class="theme--tuktuk__checkout__bump__item__product__price">Rp {{ bumpData.bumpPrice | g_number_format }}</p>
          </div>
        </div>

        <div class="theme--tuktuk__checkout__bump__item__action">
            <vs-checkbox v-model="data.selectedbumpArray" :key="i" :val="bumpData" class="theme--tuktuk__checkbox">
              <template #icon >
                <img src="@/assets/icons/TuktukTheme/checklist--pink.svg" class="theme--tuktuk__checkbox__active"/>
              </template>
              {{ bumpData.bumpText3 }}
            </vs-checkbox>
            <input type="hidden" disabled class="checkbox-text bumpText3 ml-2" v-model="bumpData.bumpText3" />
        </div>
      </div>
      <BumpPhotoViewer ref="photoViewer" />
    </div>
</template>
<script>
import config from "./../../../../config.js";
import { getSizedImageUrl } from "@/helpers/imagekitHelper";
import BumpPhotoViewer from "./BumpPhotoViewer.vue";

export default {
  props: ["data"],
  data() {
    return {
      baseUrl: config.api.replace("/api", ""),
      getSizedImageUrl
    };
  },
  components: {
    BumpPhotoViewer,
  },
  methods: {
    addBumpOrder(event,bumpData){      
      if(event.target.className!='vs-checkbox'){      
        const bumpIndex=this.data.selectedbumpArray.findIndex(x=>x.bump_id==bumpData.bump_id);
        if(bumpIndex==-1){
          this.data.selectedbumpArray.push(bumpData);
        }else{
          this.data.selectedbumpArray.splice(bumpIndex,1);
        }         
        event.preventDefault();      
     }
    },  
  }
};
</script>

<style scoped>
.theme--Tuktuk  #checkout-content--right .checkout-content--right__bump .embed-checkout-right__bump__item{
    border: 1px solid #E8E8E8
  }
  .theme--Tuktuk  #checkout-content--right .checkout-content--right__bump .embed-checkout-right__bump__item .bump__item__action--buy{
    border: 1px solid #EB435B80;
    background: linear-gradient(0deg, rgba(232, 67, 89, 0.1), rgba(232, 67, 89, 0.1)),
linear-gradient(0deg, rgba(235, 67, 91, 0.5), rgba(235, 67, 91, 0.5));
color: #15171C;
  }
  .theme--Tuktuk #checkout-content--right .checkout-content--right__bump .embed-checkout-right__bump__item .bump__item__action--buy .vs-checkbox-label{
    color: #15171C !important;
  }

.bump-thumbnail-zoom {
  position: relative;
  cursor: pointer;
}
.bump-thumbnail-zoom__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(10, 10, 10, 0.25);
  opacity: 0;
  transition: opacity 0.15s;
}
.bump-thumbnail-zoom:hover .bump-thumbnail-zoom__overlay {
  opacity: 1;
}
/* Highlight Foto Bump: full-width square photo above the text instead of the 73px thumbnail column */
.theme--tuktuk__checkout__bump__item__content.bump-highlight {
  display: flex !important;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 8px !important;
}
.bump-highlight .theme--tuktuk__checkout__bump__item--show-thumbnail__container {
  width: 100% !important;
  aspect-ratio: 1 / 1;
}
.bump-highlight .theme--tuktuk__checkout__bump__item--show-thumbnail__container > img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}
/* the theme sizes every img in the thumbnail container to 73px */
.bump-thumbnail-zoom .bump-thumbnail-zoom__overlay img {
  width: 24px !important;
  height: 24px !important;
}




</style>